import React from 'react';
import PropTypes from 'prop-types';
import Async from 'react-select/async';
import { components } from 'react-select';
import axios from 'axios';

import { ucwords } from '../../lib/strings';

const AdminSelect = ({
  value,
  isMulti = false,
  onChange,
  showDefaultOptions = false,
  usePublic = false,
  includeAllOption = false,
  filterRoles = null,
  showUserType = true,
  style = {},
  required = false,
}) => {
  const Input = (props) => {
    return <components.Input {...props} />;
  };

  const Option = (props) => {
    const record = props.data.record;
    return (
      <components.Option {...props}>
        <span className="mb-0">{props.children}</span>
        {showUserType && !usePublic && record.userType && (
          <small className="text-muted">{ucwords(record.userType)}</small>
        )}
      </components.Option>
    );
  };

  const loadOptions = async (term) => {
    const q = term ? String(term) : '';
    // Optional role restriction (e.g. only Onboarding Specialists can own leads).
    // Backend getUsers filters by roles.roleName via the `filterRoles` param.
    const roleFilter =
      !usePublic && filterRoles
        ? `&filterRoles=${encodeURIComponent(filterRoles)}`
        : '';
    // assignable=true: users flagged userAssignable=false (people who must
    // never be assigned work, e.g. the CEO) are hidden from every picker
    // built on this component.
    const endpoint = usePublic
      ? `/public/admins?search=${encodeURIComponent(q)}`
      : `/users?search=${encodeURIComponent(q)}&userType=internal&assignable=true${roleFilter}`;

    // Fetch admins
    const adminResults = await axios.get(endpoint);
    const opts = [];

    if (includeAllOption) {
      opts.push({
        value: '__ALL__',
        label: 'All Internal Users',
        type: 'user',
        record: {
          userType: '',
        },
      });
    }

    // Add admin/user options
    adminResults.data.rows.forEach((item) => {
      opts.push({
        value: item.userId,
        label: `${item.userLastName}, ${item.userFirstName}`,
        type: 'user',
        record: item,
      });
    });

    // Sort all options alphabetically by label
    opts.sort((a, b) => a.label.localeCompare(b.label));

    return opts;
  };
  return (
    <Async
      components={{ Option, Input }}
      isMulti={isMulti}
      isClearable={true}
      isSearchable={true}
      loadOptions={loadOptions}
      onChange={onChange}
      value={value}
      defaultOptions={showDefaultOptions}
      styles={style}
      required={required}
    />
  );
};

AdminSelect.propTypes = {
  value: PropTypes.any,
  isMulti: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  showDefaultOptions: PropTypes.bool,
  usePublic: PropTypes.bool,
  includeAllOption: PropTypes.bool,
  filterRoles: PropTypes.string,
  showUserType: PropTypes.bool,
  style: PropTypes.object,
  required: PropTypes.bool,
};

export default AdminSelect;
